<div class="badge badge--{{cls}}" [class.badge--full]="!compact" [class.badge--compact]="compact" [matTooltip]="tooltip">
  <mat-icon *ngIf="icon" class="badge__icon" [svgIcon]="icon"></mat-icon>
  <span *ngIf="!compact" class="badge__label">{{ label }}</span>
</div>
